import { forEach } from 'components/react-document-meta/utils';

function removeNode(node) {
  node.parentNode.removeChild(node);
}

export function removeDocumentMeta() {
  forEach(document.querySelectorAll('head [data-rdm]'), removeNode);
}

function insertDocumentMetaNode(entry) {
  const { tagName, ...attr } = entry;

  const newNode = document.createElement(tagName);
  for (const prop in attr) {
    if (entry.hasOwnProperty(prop)) {
      newNode.setAttribute(prop, entry[prop]);
    }
  }
  newNode.setAttribute('data-rdm', '');
  document.getElementsByTagName('head')[0].appendChild(newNode);
}

export function insertDocumentMeta(nodes) {
  removeDocumentMeta();

  forEach(nodes, insertDocumentMetaNode);
}
